module.exports = __webpack_public_path__ + "img/cdu-kandidat.914ae58b.png";